// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"90e9f4f3","186":"858e08fc","344":"6bf79d14","372":"95a09e88","738":"1fb0f721","841":"f6613b92","856":"647f6b56"}[chunkId] + ".chunk.js";
};